import React, { Component } from "react";
import {
  Col,
  Row,
  Container,
  Modal,
  Card,
  CardHeader,
  Table,
  Button,
  DropdownItem,
  ButtonDropdown,
  DropdownMenu,
  DropdownToggle
} from "reactstrap";
import DetailedOrderCard from "../../components/DetailedOrderCard";
import RequestManager from "../../singletons/RequestManager";
import moment from "moment";
import LoadingOverlay from "react-loading-overlay";

// import { DateRangePicker } from "react-dates";
// import "react-dates/lib/css/_datepicker.css";

// moment.tz.link("Asia/Calcutta|Asia/Kolkata");

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { CSVLink } from "react-csv";

// let momentIST = moment.tz.add("Asia/Calcutta|HMT BURT IST IST|-5R.k -6u -5u -6u|01232|-18LFR.k 1unn.k HB0 7zX0").link("Asia/Calcutta|Asia/Kolkata");

export default class MerchantOrderSummary extends Component {
  constructor(props) {
    super(props);
    this.state = {
      orders: [],
      orderModalVisible: false,
      focusedDate: null,
      storeInformation: null,
      startDate: moment().endOf("day"),
      endDate: moment().endOf("day"),
      pageText: "Your past orders",
      grandTotal: 0.0,
      dropdownOpen: false,
      selectedStore: null,
      stores: [],
      merchantNames: [],
      storeIds: [],
      merchantName: null,
      selectedName: null,
      selectedStoreID: "",
      loading: false,
      loadingValue: "Please select merchant",
      spinnerLoading: false
    };
  }

  componentWillMount() {
    let reloadActive = localStorage.getItem("reloadActive");
    if (reloadActive === null) {
      localStorage.setItem("reloadActive", "Y");

      window.location.reload();
    }
    this.checkLoginMode();
  }
  componentDidMount() {}

  handleChange = event => {
    this.setState({ orders: [], grandTotal: 0.0 });

    for (let i = 0; i < this.state.merchantNames.length; i++) {
      if (this.state.merchantNames[i].node.name === event.target.value) {
        this.getStores(this.state.merchantNames[i].node.id);

        break;
      }
    }
  };
  getStores = async merchantId => {
    let requestManager = new RequestManager();
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getStores",
      {
        merchantId: merchantId
      }
    );

    if (response.error === null) {
      if (response.data.merchant.stores.edges.length > 0) {
        this.setState({
          stores: response.data.merchant.stores.edges,
          selectedStoreID: response.data.merchant.stores.edges[0].node.id
        });
        this.getOrders();
      }
    }
  };
  checkLoginMode = () => {
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "merchant") {
      this.setState({
        storeInformation: storeInformation,
        pageText: "Your Order Summary"
      });
      this.getOrders();
    } else if ("concessionaire") {
      this.setState({
        storeInformation: storeInformation,
        storeIds: storeInformation.concessionaire,
        pageText: "Your Order Summary"
      });
      this.getMerchantDetails();
    } else {
      this.setState({ storeInformation: storeInformation });
      this.getOrders();
    }
  };

  getMerchantDetails = async () => {
    let requestManager = new RequestManager();

    let response = await requestManager.getResponseFromPredefinedQuery(
      "getMerchantName"
    );

    if (response.error === null) {
      this.state.merchantNames.push({
        node: { name: "Select Merchant", id: "123" }
      });
      for (let i = 0; i < response.data.merchants.edges.length; i++) {
        this.state.merchantNames.push(response.data.merchants.edges[i]);
      }

      this.setState({ merchantNames: this.state.merchantNames });
    }
  };
  toggleModal = () => {
    this.setState({
      orderModalVisible: !this.state.orderModalVisible
    });
  };

  getOrders = async () => {
    this.setState({
      orders: [],
      grandTotal: 0.0,
      loadingValue: "Please Wait a moment, loading",
      loading: false,
      spinnerLoading: true
    });
    let requestManager = new RequestManager();
    let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));

    let loginMode = localStorage.getItem("loginMode");
    let params = {};
    if (loginMode === "store") {
      params = {
        storeId: storeInformation.store.id
      };
    } else if (loginMode === "merchant") {
      params = {
        merchantId: storeInformation.merchant.id
      };
    } else if (loginMode === "concessionaire") {
      params = {
        storeId: this.state.selectedStoreID
      };
    }
    let date = "";
    if (this.state.startDate !== null) {
      date = this.state.startDate.format("YYYY-MM-DDT");
      date = date + "00:00:00+05:30";
      params.createdAt_Gte = date;
    }
    if (this.state.endDate !== null) {
      params.createdAt_Lte = this.state.endDate.format();
    }
    console.log(params);
    let response = await requestManager.getResponseFromPredefinedQuery(
      "getMerchantOrderDetails",
      params
    );

    if (response.error === null) {
      let grandTotal = 0.0;
      for (let i = 0; i < response.data.orderHistory.edges.length; i++) {
        grandTotal =
          grandTotal +
          response.data.orderHistory.edges[i].node.cart.settlementPrice;
      }

      if (response.data.orderHistory.edges.length === 0)
        this.setState({
          orders: response.data.orderHistory.edges,
          grandTotal: grandTotal.toFixed(2),
          loadingValue: "No Rows Found",
          loading: false,
          spinnerLoading: false
        });
      else
        this.setState({
          orders: response.data.orderHistory.edges,
          grandTotal: grandTotal.toFixed(2),
          loading: true,
          spinnerLoading: false
        });
    } else {
      this.setState({
        loading: false,
        spinnerLoading: false
      });
    }

    console.log(response);
  };

  getCountOfItems = () => {
    if (this.state.selectedOrder) {
      let cartItems = this.state.selectedOrder.node.cart.cartItems.edges;
      let quantity = 0;
      cartItems.forEach(cartItem => {
        quantity = quantity + cartItem.node.quantity;
      });

      return quantity;
    }
  };

  getCSVData = () => {
    let date = "";
    if (this.state.startDate !== null) {
      date = this.state.startDate.format("YYYY-MM-DD");
      // date = date+"00:00:00+05:30";
    }
    let csvData = [
      [this.state.pageText],

      ["Grand Total", "Start Date", "End Date"],
      [this.state.grandTotal, date, this.state.endDate.format("YYYY-MM-DD")],
      [""],
      [""],
      [
        "Order Id",
        "Token",
        "Status",
        "Date/Time",
        "SubTotal",
        "Discount",
        "Tax Amount",
        "Grand Amount",
        "Store Name",
        "Store Running BillId",
        "Store Code",
        "Store Pos Code"
      ]
    ];
    // eslint-disable-next-line
    this.state.orders.map(order => {
      csvData.push([
        order.node.orderId,
        order.node.storeToken,
        order.node.status,
        moment(order.node.createdAt)
          .utcOffset("+05:30")
          .format("MMMM DD YYYY, h:mm a"),
        order.node.cart.subtotal,
        this.getDiscountAmount(order.node.cart.settlementExtra),
        this.getGSTAndCGST(order.node.cart.settlementExtra),
        order.node.cart.settlementPrice,
        order.node.cart.pickupPoint.store.name,
        order.node.storeRunningBillId,
        order.node.cart.pickupPoint.store.referenceStoreCode,
        order.node.cart.pickupPoint.store.referenceStorePosCode
      ]);
    });
    return csvData;
  };
  handleStartDateChange = date => {
    this.setState({
      startDate: date
    });
  };
  handleEndDateChange = date => {
    if (
      Date.parse(this.state.startDate.format("MM/DD/YYYY")) >=
      Date.parse(date.format("MM/DD/YYYY"))
    ) {
      if (
        Date.parse(this.state.startDate.format("MM/DD/YYYY")) ===
        Date.parse(date.format("MM/DD/YYYY"))
      ) {
        this.setState({
          endDate: date
        });
      } else {
        alert("End date should be greater than Start date");
      }
    } else {
      this.setState({
        endDate: date
      });
    }
  };
  render() {
    let loginMode = localStorage.getItem("loginMode");
    const { spinnerLoading } = this.state;
    return (
      <LoadingOverlay
        style={{ width: "100%", height: "100%", zIndex: 999 }}
        active={spinnerLoading === true ? true : false}
        spinner
        text="Loading ..."
      >
        <Container fluid style={{ padding: 0, margin: 0 }}>
          <Modal
            isOpen={this.state.orderModalVisible}
            toggle={this.toggleModal}
            size="lg"
          >
            <DetailedOrderCard
              editable={false}
              order={this.state.selectedOrder}
              toltalItemCount={null}
              goBack={this.toggleModal}
              refreshOrders={() => {}}
              pastOrder={true}
              storeInformation={this.state.storeInformation}
            />
          </Modal>

          <Row noGutters>
            <Col xs="12">
              <Card>
                <CardHeader>
                  <Container fluid>
                    <Row>
                      <h5>{this.state.pageText}</h5>
                    </Row>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        {loginMode === "concessionaire" ? (
                          <div style={{ padding: 10 }}>
                            <select onChange={this.handleChange}>
                              {this.state.merchantNames.map(names => (
                                <option>{names.node.name}</option>
                              ))}
                            </select>
                          </div>
                        ) : null}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs="12"
                        sm="12"
                        md="4"
                        lg="4"
                        style={{ display: "flex", alignItems: "center" }}
                      ></Col>

                      <Col xs="12" sm="12" md="8" lg="8">
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "flex-end"
                          }}
                        >
                          <DatePicker
                            selected={this.state.startDate}
                            maxDate={moment().endOf("day")}
                            dateFormat="DD/MM/YYYY"
                            onChange={this.handleStartDateChange}
                          />
                          <div style={{ marginLeft: 15 }}>
                            <DatePicker
                              selected={this.state.endDate}
                              dateFormat="DD/MM/YYYY"
                              maxDate={moment().endOf("day")}
                              onChange={this.handleEndDateChange}
                            />
                          </div>

                          <h5 style={{ marginLeft: 20 }}>
                            {"Grand Total= " + this.state.grandTotal}
                          </h5>
                          <Button
                            style={{
                              marginLeft: 20,
                              backgroundColor: "#00a9db",
                              color: "white"
                            }}
                            onClick={this.getOrders}
                          >
                            Submit
                          </Button>
                          {
                            // <DateRangePicker
                            //   startDate={this.state.startDate}
                            //   startDateId={"unique_start_date_id"}
                            //   endDate={this.state.endDate}
                            //   endDateId={"unique_start_date_id"}
                            //   focusedInput={this.state.focusedDate}
                            //   displayFormat="DD[/]MM[/]YYYY"
                            //   small={true}
                            //   isOutsideRange={day => {
                            //     return moment().endOf("day") <= day;
                            //   }}
                            //   onDatesChange={({ startDate, endDate }) => {
                            //     if (endDate != null) {
                            //       this.setState(
                            //         {
                            //           startDate: startDate.startOf("day"),
                            //           endDate: endDate.endOf("day"),
                            //           orders: []
                            //         },
                            //         () => {
                            //           this.getOrders();
                            //         }
                            //       );
                            //     }
                            //   }}
                            //   onFocusChange={focusedDate =>
                            //     this.setState({ focusedDate: focusedDate })
                            //   }
                            //   orientation="vertical"
                            // />
                            /* <Button disabled={this.state.orders.length <= 0} color='primary' onClick={this.exportDataToCSV} style={{marginLeft:10}}>Export to CSV</Button> */
                          }
                          <CSVLink
                            className="btn btn-primary"
                            style={{ marginLeft: 20 }}
                            filename={"OrderSummary.csv"}
                            data={this.getCSVData()}
                          >
                            Export to CSV
                          </CSVLink>
                        </div>
                      </Col>
                    </Row>
                  </Container>
                </CardHeader>
                <Table responsive>
                  <tbody>
                    <tr>
                      <th>Order Id</th>
                      <th>Token</th>
                      <th>status</th>
                      <th>Date/Time</th>
                      <th>SubTotal</th>
                      <th>DiscountAmt</th>
                      <th>TaxAmt</th>
                      <th>TotalAmt</th>
                      <th>Store</th>
                      <th>StoreRunningBillId</th>
                      <th>StoreCode</th>
                      <th>StorePosCode</th>
                    </tr>
                    {this.state.loading === false ? (
                      <tr>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td style={{ textAlign: "center" }}>
                          {this.state.loadingValue}
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td></td>
                      </tr>
                    ) : (
                      this.state.orders.map(order => {
                        return (
                          <tr
                            key={order.node.id}
                            onClick={() => {
                              this.setState({ selectedOrder: order });
                              this.toggleModal();
                            }}
                          >
                            <td>{order.node.orderId}</td>
                            <td>{order.node.storeToken}</td>
                            <td>{order.node.status}</td>
                            <td>
                              {moment(order.node.createdAt)
                                .utcOffset("+05:30")
                                .format("MMMM DD YYYY, h:mm a")}
                            </td>
                            <td>{"₹" + order.node.cart.subtotal}</td>

                            <td>
                              {" "}
                              {this.getDiscountAmount(
                                order.node.cart.settlementExtra
                              )}
                            </td>
                            <td>
                              {" "}
                              {this.getGSTAndCGST(
                                order.node.cart.settlementExtra
                              )}
                            </td>
                            <td>{"₹" + order.node.cart.settlementPrice}</td>
                            <td>{order.node.cart.pickupPoint.store.name}</td>
                            <td>{order.node.storeRunningBillId}</td>
                            <td>
                              {
                                order.node.cart.pickupPoint.store
                                  .referenceStoreCode
                              }
                            </td>
                            <td>
                              {
                                order.node.cart.pickupPoint.store
                                  .referenceStorePosCode
                              }
                            </td>
                          </tr>
                        );
                      })
                    )}
                  </tbody>
                </Table>
              </Card>
            </Col>
          </Row>
        </Container>
      </LoadingOverlay>
    );
  }
  renderStorePicker = () => {
    let loginMode = localStorage.getItem("loginMode");
    if (loginMode === "concessionaire") {
      return (
        <div>
          <ButtonDropdown
            isOpen={this.state.dropdownOpen}
            toggle={() => {
              this.setState({ dropdownOpen: !this.state.dropdownOpen });
            }}
          >
            <DropdownToggle caret>
              {this.state.selectedStore
                ? this.state.selectedStore.name
                : "Fetching stores.."}
            </DropdownToggle>
            <DropdownMenu right>
              <DropdownItem header>Choose a store</DropdownItem>
              {this.state.stores.map(store => (
                <DropdownItem
                  key={store.node.id}
                  onClick={() => {
                    this.storeSelected(store.node);
                  }}
                >
                  {store.node.name}
                </DropdownItem>
              ))}
            </DropdownMenu>
          </ButtonDropdown>
        </div>
      );
    }

    return <div />;
  };

  getGSTAndCGST = extraText => {
    let extra = JSON.parse(extraText);
    // eslint-disable-next-line
    let offers = extra.offer === null ? [] : extra.offer;
    let charges = extra.charge === null ? [] : extra.charge;
    let gst_cgst = 0;
    for (let i = 0; i < charges.length; i++) {
      gst_cgst = gst_cgst + charges[i].amount;
    }
    return gst_cgst;
  };
  getDiscountAmount = extraText => {
    let extra = JSON.parse(extraText);
    let offersAmount = 0;
    if (extra.hasOwnProperty("offer")) {
      let offers = extra.offer === null ? [] : extra.offer;

      for (let i = 0; i < offers.length; i++) {
        offersAmount = offersAmount + offers[i].amount;
      }
    }
    return offersAmount;
  };
}



// WEBPACK FOOTER //
// ./src/pages/MerchantOrderSummary/MerchantOrderSummary.js